import { render, staticRenderFns } from "./GlobalTermsModal.vue?vue&type=template&id=49a2764f&"
import script from "./GlobalTermsModal.vue?vue&type=script&lang=js&"
export * from "./GlobalTermsModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTermsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports